export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-05.jpg'),
        title: '大数据',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '数据比以往任何时候都更加根植于我们生活中的每个角落.',
      description: `<p style="font-size:1.05rem">今天，数据比以往任何时候都更加根植于我们生活中的每个角落，我们用数据去解决问题、改善福利，并且促成新的经济繁荣。伴随着数据处理能力的提升、运算与储存成本的井喷及越来越多的设备中嵌入各种传感技术，数据的收集、储存与分析正处于一个近乎无限上升的趋势，随着技术成熟，我们的设备、交通工具和迅速发展的“可穿戴”科技将能互相连接与沟通。</p>
      <p>
我们的技术: 大数据采集：通过突破分布式高速可靠数据采集、高速全映像等大数据采集技术，对数据进行提取、转换、加载，最终挖掘数据的潜在价值;
大数据预处理：再数据挖掘之前，通过数据清理、数据集成、数据变换、数据归约等方式对数据进行处理，提高数据挖掘的质量，降低数据挖掘的时间;
大数据管理存储及管理：采用Hadoop的分布式存储技术，提高数据的存储管理能力;
大数据分析及挖掘：离线分析、准实时分析、实时分析、图片识别、语音识别、机器学习；MapReduce、Hive、Pig、Spark、Flink、Impala、Kylin、Tez、Akka、Storm、S4、Mahout、MLlib;
大数据展现及运用
</p>`
    },
    {
      title: '我们的服务',
      description:`<span class='img' style="background:url(`+require('../../../assets/images/services/pic-05.jpg')+`)"></span>
      <span class="list">
      <i></i>一站式开发<br/>
      <i></i>开放灵活<br/>
      <i></i>成熟稳定<br/>
      <i></i>安全可靠<br/>
      <i></i>优质服务
      </span>`
    }
  ]
}
